import Text from 'components/Text/Text';
import React from 'react';
import { Checkbox, Form } from 'antd';

interface IShowLoyaltyProgramButtonsCheckBox {
	toggleShowLoyaltyProgramButtons: () => void;
	isShowLoyaltyProgramButtons: boolean;
	isShowCustomerLoyaltyProgramButtons: boolean;
}

const ShowLoyaltyProgramButtonsCheckBox: React.FC<IShowLoyaltyProgramButtonsCheckBox> = ({
	toggleShowLoyaltyProgramButtons,
	isShowLoyaltyProgramButtons,
	isShowCustomerLoyaltyProgramButtons,
}) => {
	return (
		<Form.Item name="isShowLoyaltyProgramButtons" data-test="ShowLoyaltyProgramButtonsCheckBox">
			<Checkbox
				checked={isShowLoyaltyProgramButtons}
				disabled={!isShowCustomerLoyaltyProgramButtons}
				onChange={toggleShowLoyaltyProgramButtons}>
				<Text translationNameSpace="form" translationKey="showLoyaltyProgramButtonsLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(ShowLoyaltyProgramButtonsCheckBox);
